'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _eventEmitter = require('./eventEmitter.c');

var _eventEmitter2 = _interopRequireDefault(_eventEmitter);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dataModel = require('../../../common/backbone/dataModel');

var _dataModel2 = _interopRequireDefault(_dataModel);

var _escapeRegExp2 = require('../utils/escapeRegExp.u');

var _escapeRegExp3 = _interopRequireDefault(_escapeRegExp2);

var _formatter2 = require('../utils/formatter.u');

var _formatter3 = _interopRequireDefault(_formatter2);

var _sync = require('../../../common/backbone/sync/sync');

var _sync2 = _interopRequireDefault(_sync);

var _dataCollection = require('../../../common/backbone/dataCollection');

var _dataCollection2 = _interopRequireDefault(_dataCollection);

var _l10n2 = require('../../../common/l10n');

var _l10n3 = _interopRequireDefault(_l10n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_EventEmitter) {
    _inherits(_class, _EventEmitter);

    function _class() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, _class);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.uiStates = {
            // начальное состояние, инициализация компонента
            INITIAL: 'initial',
            // активное состояние, UI готов к взаимодействию
            INTERACTIVE: 'interactive',
            // подготовка UI к отображению, загрузка необходимых для работы данных
            STANDBY: 'standby',
            // обработка действий пользователя
            PROCESSING: 'processing',
            // ошибка
            ERROR: 'error',
            // компонент скрыт
            HIDDEN: 'hidden',
            // пройденный шаг (для StepController)
            PASSED: 'passed',
            // component is in redirect
            REDIRECT: 'redirect'
        }, _this.viewportTypes = {
            DESKTOP: 'desktop',
            TABLET: 'tablet',
            MOBILE: 'mobile'
        }, _this.fetchBeforeRender = [], _temp), _possibleConstructorReturn(_this, _ret);
    }

    // pre fetching for supplied storages.
    // ex: ['model', 'collection', 'cards'] will execute fetch method of this.state.model || this.props.model etc...


    _createClass(_class, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.processModelData(null, this.props.params, { silent: true });
            return this;
        }

        /**
         * При обновлении props необходимо обработать props.params
         * обновленные данные из props.params сэтятся в модель
         * в основном запускается при обновлении роута
         * @param {object} nextProps
         */

    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.processModelData(this.props.params, nextProps.params);
        }

        /**
         * определяет изменение состояния компонента
         * необходим для проверки изменения компонента
         * путем вызова shouldComponentUpdate
         * @param {object} nextProps
         * @param {object} nextState
         * @return {object}
         */

    }, {
        key: 'isComponentChanged',
        value: function isComponentChanged(nextProps, nextState) {
            var _this2 = this;

            var changed = void 0,
                nextPropsMap = Object.keys(nextProps),
                currencyPropsMap = Object.keys(this.props);

            // inner state changed
            changed = (this.state && this.state.ui) !== nextState.ui;

            // props count changed
            if (!changed) {
                changed = nextPropsMap.length !== currencyPropsMap.length;
            }

            // props keys changed
            if (!changed) {
                changed = !!currencyPropsMap.find(function (prop) {
                    return nextPropsMap.indexOf(prop) < 0;
                });
            }

            // model preset params changed
            if (!changed && this.props.params && nextProps.params) {
                var prevParams = this.props.params,
                    nextParams = nextProps.params;

                try {
                    prevParams = JSON.stringify(prevParams);
                } catch (e) {
                    prevParams = '';
                }

                try {
                    nextParams = JSON.stringify(nextParams);
                } catch (e) {
                    nextParams = '';
                }

                changed = prevParams !== nextParams;
            }

            // props values changed
            if (!changed) {
                changed = !!currencyPropsMap.find(function (prop) {
                    return _this2.props[prop] !== nextProps[prop];
                });
            }

            return changed;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            // загрузим коллекцию и/или модель вьюхи
            this.loadStorages();

            return this;
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // flag for unmounted components
            this.isUnmounted = true;
            this.stopListening();
            this.off();
        }

        /**
         * lifecycle method. Run after all storages (fetchBeforeRender) are loaded and state become INTERACTIVE
         */
        /* componentReady() {
        }*/

        /**
         * lifecycle method. Run after all storages (fetchBeforeRender) are loaded and state still STANDBY
         * @param {function} resolve
         * @return {Promise.resolve}
         */

        /* componentWillReady(resolve) {
            return resolve();
        }*/

        /**
         * override
         * ensure that setState called on mounted component
         * @param {object} state
         * @param {function} [cb]
         * @return {Promise}
         */

    }, {
        key: 'setState',
        value: function setState(state, cb) {
            var _this3 = this;

            if (!this.isUnmounted) {
                if (typeof cb === 'function') {
                    return _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'setState', this).call(this, state, cb);
                } else {
                    return new Promise(function (resolve, reject) {
                        _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'setState', _this3).call(_this3, state, function () {
                            return resolve();
                        });
                    });
                }
            } else {
                return Promise.resolve();
            }
        }

        /**
         * override for Promise implementation
         * @param {function} [cb]
         * @return {Promise}
         */

    }, {
        key: 'forceUpdate',
        value: function forceUpdate(cb) {
            var _this4 = this;

            if (!this.isUnmounted) {
                if (typeof cb === 'function') {
                    return _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'forceUpdate', this).call(this, cb);
                } else {
                    return new Promise(function (resolve) {
                        _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'forceUpdate', _this4).call(_this4, function () {
                            return resolve();
                        });
                    });
                }
            } else {
                return Promise.resolve();
            }
        }
    }, {
        key: 'isUiInitial',
        value: function isUiInitial() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state && this.state.ui;

            return state === this.uiStates.INITIAL;
        }
    }, {
        key: 'isUiInteractive',
        value: function isUiInteractive() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state && this.state.ui;

            return state === this.uiStates.INTERACTIVE;
        }
    }, {
        key: 'isUiStandBy',
        value: function isUiStandBy() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state && this.state.ui;

            return state === this.uiStates.STANDBY;
        }
    }, {
        key: 'isUiProcessing',
        value: function isUiProcessing() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state && this.state.ui;

            return state === this.uiStates.PROCESSING;
        }
    }, {
        key: 'isUiError',
        value: function isUiError() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state && this.state.ui;

            return state === this.uiStates.ERROR;
        }
    }, {
        key: 'isUiHidden',
        value: function isUiHidden() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state && this.state.ui;

            return state === this.uiStates.HIDDEN;
        }
    }, {
        key: 'isUiPassed',
        value: function isUiPassed() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state && this.state.ui;

            return state === this.uiStates.PASSED;
        }
    }, {
        key: 'isUiRedirect',
        value: function isUiRedirect() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state && this.state.ui;

            return state === this.uiStates.REDIRECT;
        }
    }, {
        key: 'uiInteractive',
        value: function uiInteractive() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this.setState(Object.assign({ error: null }, data, { ui: this.uiStates.INTERACTIVE }));
        }
    }, {
        key: 'uiStandBy',
        value: function uiStandBy() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this.setState(Object.assign({ error: null }, data, { ui: this.uiStates.STANDBY }));
        }
    }, {
        key: 'uiProcessing',
        value: function uiProcessing() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this.setState(Object.assign({ error: null }, data, { ui: this.uiStates.PROCESSING }));
        }
    }, {
        key: 'uiError',
        value: function uiError() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this.setState(Object.assign({}, data, { ui: this.uiStates.ERROR }));
        }
    }, {
        key: 'uiHidden',
        value: function uiHidden() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this.setState(Object.assign({ error: null }, data, { ui: this.uiStates.HIDDEN }));
        }
    }, {
        key: 'uiPassed',
        value: function uiPassed() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this.setState(Object.assign({ error: null }, data, { ui: this.uiStates.PASSED }));
        }
    }, {
        key: 'uiRedirect',
        value: function uiRedirect() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this.setState(Object.assign({ error: null }, data, { ui: this.uiStates.REDIRECT }));
        }
    }, {
        key: 'isViewportTablet',
        value: function isViewportTablet() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            return this.getViewport(props) === this.viewportTypes.TABLET;
        }
    }, {
        key: 'isViewportMobile',
        value: function isViewportMobile() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            return this.getViewport(props) === this.viewportTypes.MOBILE;
        }
    }, {
        key: 'isViewportLaptop',
        value: function isViewportLaptop() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            return this.getViewport(props) === this.viewportTypes.DESKTOP;
        }
    }, {
        key: 'getViewport',
        value: function getViewport() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            return this.viewport || this.state && this.state.viewport || props.viewport || this.viewportTypes.DESKTOP;
        }
    }, {
        key: 'render',
        value: function render() {
            var result = null,
                template = void 0,
                ui = this.state && this.state.ui;

            if (this.isViewportTablet()) {
                if (this.templateTablet) {
                    template = this.templateTablet;
                } else if (_typeof(this.templatesTablet) === 'object' && ui && this.templatesTablet[ui]) {
                    template = this.templatesTablet[ui];
                }
            } else if (this.isViewportMobile()) {
                if (this.templateMobile) {
                    template = this.templateMobile;
                } else if (_typeof(this.templatesMobile) === 'object' && ui && this.templatesMobile[ui]) {
                    template = this.templatesMobile[ui];
                }
            } else if (this.isViewportLaptop()) {
                if (this.templateLaptop) {
                    template = this.templateLaptop;
                } else if (_typeof(this.templatesLaptop) === 'object' && ui && this.templatesLaptop[ui]) {
                    template = this.templatesLaptop[ui];
                }
            }

            if (!template) {
                if (this.template) {
                    template = this.template;
                } else if (ui) {
                    template = this.templates[ui];
                }
            }

            if (template) {
                if (typeof template === 'function') {
                    result = template.call(this);
                } else {
                    result = template;
                }
            } else {
                result = _react2.default.createElement('div', null);

                if (process && process.env.NODE_ENV !== 'production') {
                    if (this.state && this.state.ui) {
                        console.error('Render: missed template for ' + this.state.ui + ' in component ' + this.constructor.displayName);
                    } else {
                        console.error('Render: missed template in component ' + this.constructor.displayName);
                    }
                }
            }

            return result;
        }

        /**
         * process model data, passed as this.props.params
         * set this data into model
         * if __forceSubmit flag is passed
         * this.submit method is called after component:ready
         * @param {object} prevParams
         * @param {object} nextParams
         * @param {object} opts
         * @return {object}
         */

    }, {
        key: 'processModelData',
        value: function processModelData(prevParams, nextParams) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var comparePrev = void 0,
                compareNext = void 0,
                model = this.getModel();

            if (!model || !(model instanceof _dataModel2.default) || !nextParams || (typeof nextParams === 'undefined' ? 'undefined' : _typeof(nextParams)) !== 'object') {
                return this;
            }

            try {
                comparePrev = JSON.stringify(prevParams);
                compareNext = JSON.stringify(nextParams);
            } catch (e) {
                if (process && process.env.NODE_ENV !== 'production') {
                    console.error(e + ' in component ' + this.constructor.displayName);
                }
            }

            // объекты хорошо сравниваются только стрингами =)
            if (comparePrev !== compareNext) {
                model.set(nextParams, opts);
            }

            return this;
        }

        /**
         * load all storages from fetchBeforeRender
         * non - blocking!
         * @param {object} options
         * @return {object}
         */

    }, {
        key: 'loadStorages',
        value: function loadStorages() {
            var _this5 = this;

            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var deferData = [],
                queryOptions = void 0;

            queryOptions = Object.assign({
                reset: true,
                silent: true,
                parse: true,
                validate: false
            }, options);

            if (!this.fetchBeforeRender || !(this.fetchBeforeRender instanceof Array) || !this.fetchBeforeRender.length) {
                this._handleComponentReady();
                return this;
            }

            this.fetchBeforeRender.forEach(function (storage) {
                var storageInstance = _this5.state && _this5.state[storage] || _this5.props[storage] || _this5[storage];

                if (storageInstance instanceof _dataModel2.default || storageInstance instanceof _dataCollection2.default) {
                    deferData.push(storageInstance);
                } else if (typeof storageInstance === 'function') {
                    deferData.push({
                        fetch: function fetch(options) {
                            var Transport = _sync2.default.getEngine('xhr');

                            if (Transport) {
                                return new Transport(options).get().then(function (data) {
                                    return storageInstance(data);
                                });
                            } else {
                                return Promise.resolve();
                            }
                        }
                    });
                }
            });

            if (deferData.length) {
                this.uiStandBy().then(function () {
                    return Promise.all(deferData.map(function (item) {
                        // load storages is non blocking procedure, resolve and reject are equal
                        return new Promise(function (resolve) {
                            item.fetch(queryOptions).then(function (response) {
                                return resolve(response);
                            }, function (error) {
                                return resolve(error);
                            });
                        });
                    }));
                }).then(function () {
                    return _this5._handleComponentReady();
                });
            } else {
                this._handleComponentReady();
            }

            return this;
        }
    }, {
        key: '_handleComponentReady',
        value: function _handleComponentReady() {
            var _this6 = this;

            var ready = void 0;

            // componentWillReady can contain async code, so use Promise
            ready = new Promise(function (resolve, reject) {
                if (typeof _this6.componentWillReady === 'function') {
                    _this6.componentWillReady(resolve);
                } else {
                    resolve();
                }
            });

            ready.then(function () {
                _this6.uiInteractive().then(function () {
                    if (typeof _this6.componentReady === 'function') {
                        _this6.componentReady();
                    }
                });
            });

            return this;
        }

        /**
         * get data
         * from current refs
         * from extraData method
         * @return {*}
         */

    }, {
        key: 'getFormData',
        value: function getFormData() {
            var data = {},
                extraData = void 0,
                refs = Object.assign({}, this.refs, this.crefs || {}),
                keys = Object.keys(refs),
                ref = void 0;

            keys.forEach(function (name) {
                ref = refs[name];

                if (ref && !(ref instanceof HTMLElement) && typeof ref.getFormData === 'function') {
                    var refData = ref.getFormData();

                    if ((typeof refData === 'undefined' ? 'undefined' : _typeof(refData)) === 'object') {
                        data = Object.assign({}, data, refData);
                    }
                }
            });

            if (typeof this.getFormExtraData === 'function') {
                extraData = this.getFormExtraData(data);
            }

            return Object.assign({}, data, extraData);
        }

        /**
         * Usual props list for bind component to DataModel storage.
         * Supported all components from P24C collection
         * @param {string} attribute
         * @param {object} props
         * @return {*}
         */

    }, {
        key: 'bindProps',
        value: function bindProps(attribute) {
            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var result = {};

            if (attribute) {
                this._removeErrorOnModelChange(attribute);

                result = Object.assign({
                    elementRef: this._bindElementRef.bind(this),
                    storage: this.getModel(),
                    attribute: attribute,
                    bind: true,
                    error: !!this._matchError({ name: attribute }),
                    // common props
                    viewport: this.getViewport()
                }, props);
            }

            return result;
        }
    }, {
        key: '_removeErrorOnModelChange',
        value: function _removeErrorOnModelChange(attribute) {
            var _this7 = this;

            var storage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getModel();

            this._removeErrorListeners = this._removeErrorListeners || {};

            if (!this._removeErrorListeners[attribute] && storage instanceof _dataModel2.default && attribute) {
                this.listenTo(storage, 'change:' + attribute, function () {
                    if (_this7._matchError({ name: attribute })) {
                        _this7.removeError({ name: attribute });
                    }
                });

                this._removeErrorListeners[attribute] = true;
            }
        }
    }, {
        key: '_bindElementRef',
        value: function _bindElementRef(el) {
            this.crefs = this.crefs || {};

            if (el !== null) {
                if (el instanceof HTMLElement && el.name) {
                    this.crefs[el.name] = el;
                } else if (el.props && el.props.attribute) {
                    this.crefs[el.props.attribute] = el;
                }
            }
        }

        /**
         * Usual property set for controlled components.
         * @param {string} [name]
         * @param {object} props
         * @return {object}
         */

    }, {
        key: 'ctrlProps',
        value: function ctrlProps(name) {
            var _this8 = this;

            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            this.crefs = this.crefs || {};

            var ref = void 0,
                error = false,
                attribute = null,
                value = null,
                checked = null,
                onChange = null;

            if (name) {
                ref = this._bindElementRef.bind(this);

                attribute = name;
                error = !!this._matchError({ name: name });
                value = this.state ? this.state[name] : null;
                checked = typeof value === 'boolean' ? value : null;
                onChange = function onChange() {
                    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                    var value = void 0;

                    if (event.target) {
                        if (event.target.type === 'checkbox') {
                            value = event.target.checked;
                        } else {
                            value = event.target.value;
                        }
                    } else {
                        value = event;
                    }

                    return _this8.setState(_defineProperty({}, name, value)).then(function () {
                        if (_this8._matchError({ name: attribute })) {
                            return _this8.removeError({ name: attribute });
                        } else {
                            return Promise.resolve();
                        }
                    });
                };
            }

            return Object.assign({
                elementRef: ref,
                bind: false,
                error: error,
                attribute: attribute,
                value: value,
                checked: checked,
                onChange: onChange,
                // common props
                viewport: this.getViewport()
            }, props);
        }
    }, {
        key: '_matchError',
        value: function _matchError() {
            var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state && this.state.error;

            var result = null;

            if (list && list.length) {
                result = list.find(function (subject) {
                    return pattern.name === subject.name;
                });
            }

            return result;
        }

        /**
         * обработчик ошибок
         * отрисовка ошибки
         * @param {object|Array} errorList
         * @return {Promise}
         */

    }, {
        key: 'errorHandler',
        value: function errorHandler(errorList) {
            var _this9 = this;

            if (!errorList) {
                return Promise.resolve();
            }

            errorList = errorList instanceof Array ? errorList : [errorList];

            var newList = [],
                currentList = this.state && this.state.error || [];

            // заменяем дубликаты новыми копиями
            currentList.forEach(function (error) {
                newList.push(_this9._matchError(error, errorList) || error);
            });

            // дополняем список новыми ошибками
            errorList.forEach(function (error) {
                if (!_this9._matchError(error, newList)) {
                    newList.push(error);
                }
            });

            return this.uiError({ error: newList });
        }

        /**
         * opts: error filter
         * opts.name - remove only {name} errors;
         * @param {object} [errorList]
         * @return {Promise}
         */

    }, {
        key: 'removeError',
        value: function removeError(errorList) {
            var _this10 = this;

            if (errorList) {
                errorList = errorList instanceof Array ? errorList : [errorList];
            } else {
                errorList = [];
            }

            return new Promise(function (resolve) {
                if (_this10.isUiError() && _this10.state.error && _this10.state.error instanceof Array) {
                    var nextList = [];

                    // remove only selected error
                    if (errorList.length) {
                        nextList = [];

                        _this10.state.error.forEach(function (error) {
                            if (!_this10._matchError(error, errorList)) {
                                nextList.push(error);
                            }
                        });
                    }

                    if (nextList.length) {
                        _this10.setState({ error: nextList }).then(function () {
                            return resolve();
                        });
                    } else {
                        return _this10.uiInteractive({ error: null }).then(function () {
                            return resolve();
                        });
                    }
                } else {
                    resolve();
                }
            });
        }

        /**
         * getting error list, matched with passed arguments
         * if name is supplied - return only error with matched name;
         * in other cases return error without name attribute
         * @param {String} [name]
         * @return {Array}
         */

    }, {
        key: 'getError',
        value: function getError(name) {
            var _this11 = this;

            var result = [];

            if (this.isUiError() && this.state.error && this.state.error.length) {
                this.state.error.forEach(function (error) {
                    // named errors
                    if (name && error.name === name) {
                        result.push(error);
                        // unnamed errors
                    } else if (!name && !error.name) {
                        result.push(error);
                    }
                });
            }

            if (result.length) {
                result = result.map(function (error) {
                    return Object.assign({}, error, {
                        message: _this11.l10n(error.message, error.options) || 'error'
                    });
                });
            }

            return result;
        }

        /**
         * Выдает переведенную строку непосредственно для вставки в шаблон
         * @param {String} key
         * @param {Object} [options]
         * @return {String}
         */

    }, {
        key: 'l10n',
        value: function l10n(key, options) {
            return _l10n3.default.translate(key, options);
        }

        /**
         * get model of step
         * @return {*}
         */

    }, {
        key: 'getModel',
        value: function getModel() {
            return this.state && this.state.model || this.props.model || this.model || null;
        }

        /**
         * view validation. Recursive validation of each sub view.
         * @param {object} data
         * @return {*}
         */

    }, {
        key: 'validate',
        value: function validate(data) {
            var _this12 = this;

            var error = [],
                refs = Object.assign({}, this.refs, this.crefs || {}),
                keys = Object.keys(refs),
                ref = void 0,
                model = this.getModel(),
                currentValidationPassed = true,
                subValidationPassed = [];

            keys.forEach(function (name) {
                ref = refs[name];

                if (ref && !(ref instanceof HTMLElement) && typeof ref.validate === 'function') {
                    subValidationPassed.push(ref.validate());
                }
            });

            // validation of current component
            data = data || this.getFormData();

            if (model) {
                var validationData = Object.assign({}, model.attributes, data);

                var attrs = Object.keys(validationData);

                error = attrs.map(function (name) {
                    return model.validate(_defineProperty({}, name, validationData[name]), { validateValueOnly: true });
                });

                if (typeof model.extraValidate === 'function') {
                    error = error.concat(model.extraValidate(validationData));
                }
            }

            // extra validation
            if (typeof this.extraValidate === 'function') {
                error = error.concat(this.extraValidate(data));
            }

            // remove "passed" validation values like undefined, false
            error = error.filter(function (e) {
                return !!e;
            });

            this.removeError().then(function () {
                if (error.length) {
                    _this12.errorHandler(error);
                }
            });

            if (error.length) {
                currentValidationPassed = false;
            }

            return currentValidationPassed && subValidationPassed.every(function (result) {
                return result === true;
            });
        }

        /**
         * override method
         * @param {object} data
         * @return {boolean}
         */

    }, {
        key: 'extraValidate',
        value: function extraValidate(data) {
            return false;
        }

        /**
         * Распространенные проперти, которые нужно прокидывать во вложенные компоненты
         * @param {object} data
         * @return {object}
         */

    }, {
        key: 'commonProps',
        value: function commonProps() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (process && process.env.NODE_ENV !== 'production') {
                console.error('.commonProps is deprecated. Use .bindProps(attribute) for binding component and .ctrlProps(name) for controlled components');
            }

            return data;
        }

        /**
         * https://facebook.github.io/react/tips/dangerously-set-inner-html.html
         *  React dangerouslySetInnerHTML synax
         *  @param {string} html
         *  @return {object}
         */

    }, {
        key: 'rawHTML',
        value: function rawHTML() {
            var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            return { __html: html };
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.uiHidden();
        }
    }, {
        key: 'show',
        value: function show() {
            this.uiInteractive();
        }
    }, {
        key: 'formatter',
        value: function formatter() {
            return _formatter3.default.apply(undefined, arguments);
        }
    }, {
        key: 'escapeRegExp',
        value: function escapeRegExp() {
            return _escapeRegExp3.default.apply(undefined, arguments);
        }
    }]);

    return _class;
}(_eventEmitter2.default);

_class.displayName = 'Base.Views.Main';
exports.default = _class;